import apiFetch from '@wordpress/api-fetch';
import { API_PATH } from '../constants';

export default async (
  attachmentId: number,
  save: boolean = false,
  userPrompt?: string,
  signal?: AbortSignal | null,
) => {
  const requestData: {
    attachment_id: number;
    save: boolean;
    user_prompt?: string;
  } = {
    attachment_id: attachmentId,
    save,
  };

  if (userPrompt?.length) {
    requestData.user_prompt = userPrompt;
  }

  return apiFetch<{ alt: string; img_id: number }>({
    path: API_PATH,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: requestData,
    signal,
  })
    .then((response) => {
      return response.alt;
    })
    .catch((error) => {
      throw new Error(error?.message || String(error), { cause: error });
    });
};
